// extracted by mini-css-extract-plugin
module.exports = {"checkboxColumn":"CustomColumn_checkboxColumn-1XGXM"};